export default "__VITE_ASSET__BwG6P_Ft__"